module.exports = {"id":"212300","name":"Jack O'Connell","rating":"71","photo":"./data/images/photos/4/212300.png","club":{"name":"Sheffield Utd","logo":"./data/images/clubs/SheffieldUtd.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JackO'Connell0.json
// module id = 1864
// module chunks = 0